export enum ContentTaskStatusGq {
  APPROVED = 'APPROVED',
  DISAPPROVED = 'DISAPPROVED',
  PROPOSAL = 'PROPOSAL',
  UNDECIDED = 'UNDECIDED',
}
